// extracted by mini-css-extract-plugin
export default {"home_main":"home_home_main__zi-+l"};